<template>
  <div>
    <p>
      <span class="ranking-num">{{rankingNum}}</span>
      {{rankingText}}
      <span>{{rankingItemNum}}{{human}}</span>
    </p>
  </div>
</template>

<script>

export default {
  name: "PointRankingSmallText",
  data: () => ({
  }),
  methods: {
  },
  created() {
  },
  computed:{
    human() {
      if (!this.rankingText) {
        return ""
      } else {
        return "人"
      }
    }
  },
  components: {
  },
  props: ['rankingNum','rankingText', 'rankingItemNum']
};

</script>

<style scoped>
p {
  color: #fff;
  font-weight: bold;
  font-size: 1.4em;
  text-align: left;
  margin: 5px;
}
.ranking-num {
  padding-right: 20px;
}
@media screen and (max-width: 350px) {
  p {
    font-size: 0.8em;
  }
}
@media screen and (min-width: 351px) and (max-width: 768px) {
  p {
    font-size: 1.2em;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
}
@media screen and (min-width: 1024px) {
}
</style>
